module.exports = __webpack_public_path__ + "media/images/redesign-images/home/collegiate-logos/kent-state-university-ab9854f92a6fd7cd5f5d0c4714416e0c.svg";